import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, mustChangePassword, isAdmin, isSuperAdmin, isInitializing } = useSelector(
    (state) => state.auth
  );

  if (isInitializing) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (mustChangePassword) return <Navigate to="/change-password" replace />;
  if (!isAdmin && !isSuperAdmin) return <Navigate to="/" replace />;

  return children;
};

export default AdminRoute;
